import type { Editor } from '@tiptap/react';
import { MediaUploadButton } from './MediaUploadButton';

interface VideoUploadButtonProps {
  editor: Editor;
  snippetId: string;
}

export function VideoUploadButton({ editor, snippetId }: VideoUploadButtonProps) {
  return <MediaUploadButton editor={editor} snippetId={snippetId} variant="video" />;
}
